/**
 * Landing pages locales par ville — SEO longue traîne "croix pharmacie <ville>".
 * Chaque entrée contient les données SEO + contenu localisé.
 * Ajouter une nouvelle ville : dupliquer une entrée en gardant les mêmes champs.
 */

export const LOCAL_CITIES = {
  lyon: {
    slug: "lyon",
    city: "Lyon",
    departement: "Rhône",
    departementNumber: "69",
    region: "Auvergne-Rhône-Alpes",
    seoTitle: "Croix de pharmacie LED & enseignes lumineuses Lyon | Signapharma France",
    metaDescription:
      "Fabricant et installateur d'enseignes lumineuses pour pharmacies à Lyon et dans le Rhône. Croix LED programmables, lettres boîtiers, caducées lumineux — étude gratuite.",
    h1: "Croix de pharmacie et enseignes lumineuses à Lyon",
    subheading:
      "Fabricant et installateur d'enseignes lumineuses pour officines dans la métropole lyonnaise.",
    intro: [
      "Signapharma France conçoit, fabrique et installe des enseignes lumineuses pour pharmacies à Lyon et dans l'ensemble du département du Rhône. Depuis notre atelier situé à Saint-Jean-de-Gonville, dans l'Ain, à environ 45 minutes de Lyon, nous intervenons régulièrement sur l'ensemble de la métropole lyonnaise et de la région Auvergne-Rhône-Alpes.",
      "Nous accompagnons les pharmacies lyonnaises dans leurs projets de création, transfert, rénovation ou remplacement d'ancienne croix lumineuse : croix de pharmacie LED programmables, enseignes drapeaux double face, lettres boîtiers en aluminium ou en inox, caducées lumineux et logos rétroéclairés.",
    ],
    districts: [
      "Lyon 1er (Terreaux, Croix-Rousse basse)",
      "Lyon 2e (Presqu'île, Bellecour, Confluence, Perrache)",
      "Lyon 3e (Part-Dieu, Guillotière, Montchat)",
      "Lyon 4e (Croix-Rousse, Serin)",
      "Lyon 5e (Vieux-Lyon, Saint-Just, Point-du-Jour)",
      "Lyon 6e (Foch, Brotteaux, Tête d'Or)",
      "Lyon 7e (Jean-Macé, Gerland, Guillotière)",
      "Lyon 8e (Monplaisir, Grand-Trou, Bachut)",
      "Lyon 9e (Vaise, Duchère, Saint-Rambert)",
    ],
    surroundingCities: [
      "Villeurbanne",
      "Caluire-et-Cuire",
      "Bron",
      "Vénissieux",
      "Saint-Priest",
      "Écully",
      "Tassin-la-Demi-Lune",
      "Oullins",
      "Sainte-Foy-lès-Lyon",
      "Vaulx-en-Velin",
      "Rillieux-la-Pape",
      "Meyzieu",
    ],
    localSpecifics: [
      "Règlement local de publicité intercommunal (RLPi) de la Métropole de Lyon en vigueur — encadre dimensions, luminance et emplacement des enseignes.",
      "Zone urbaine dense : autorisation municipale préalable requise pour toute nouvelle enseigne lumineuse (déclaration en mairie de l'arrondissement).",
      "Extinction nocturne obligatoire entre 1 h et 6 h du matin (art. R.581-59 du Code de l'environnement).",
      "Prescriptions patrimoniales renforcées dans les secteurs sauvegardés (Vieux-Lyon, Pentes de la Croix-Rousse, Presqu'île — UNESCO).",
    ],
    services: [
      "Étude technique gratuite sur photos de façade",
      "Croix de pharmacie LED simple face ou double face (drapeau)",
      "Croix LED programmables avec animations, heure et température",
      "Lettres boîtiers en aluminium et inox pour l'enseigne principale",
      "Caducées lumineux et logos personnalisés en relief",
      "Rénovation et remplacement de croix existantes",
      "Livraison sur toute la métropole lyonnaise",
      "Pose et raccordement électrique (précisés dans chaque devis)",
    ],
  },

  annecy: {
    slug: "annecy",
    city: "Annecy",
    departement: "Haute-Savoie",
    departementNumber: "74",
    region: "Auvergne-Rhône-Alpes",
    seoTitle: "Croix de pharmacie LED & enseignes lumineuses Annecy | Signapharma France",
    metaDescription:
      "Enseignes lumineuses pour pharmacies à Annecy et en Haute-Savoie. Croix LED programmables, lettres boîtiers, caducées lumineux — étude sur mesure et pose locale.",
    h1: "Croix de pharmacie et enseignes lumineuses à Annecy",
    subheading:
      "Fabricant et installateur d'enseignes lumineuses pour officines en Haute-Savoie et sur le bassin annécien.",
    intro: [
      "Signapharma France réalise des enseignes lumineuses pour pharmacies à Annecy, ville-préfecture de la Haute-Savoie, ainsi que dans l'ensemble du bassin annécien et du Genevois français. Notre atelier de Saint-Jean-de-Gonville (Ain) est situé à environ une heure d'Annecy, ce qui nous permet d'intervenir efficacement pour les études sur site, les poses et le SAV.",
      "Nos réalisations s'adressent aux pharmacies en création, en transfert, en rénovation ou souhaitant remplacer une ancienne croix. Nous fabriquons des croix de pharmacie LED programmables, des enseignes drapeaux double face, des lettres boîtiers en aluminium ou en inox brossé, des caducées lumineux et des logos de pharmacie rétroéclairés.",
    ],
    districts: [
      "Annecy centre (Vieille Ville, Impérial)",
      "Bonlieu et front du lac",
      "Novel",
      "Cran-Gevrier",
      "Meythet",
      "Seynod",
      "Pringy",
      "Annecy-le-Vieux",
    ],
    surroundingCities: [
      "Argonay",
      "Épagny-Metz-Tessy",
      "Poisy",
      "Sillingy",
      "La Balme-de-Sillingy",
      "Alby-sur-Chéran",
      "Rumilly",
      "Faverges-Seythenex",
      "Thônes",
      "Doussard",
      "Sévrier",
      "Veyrier-du-Lac",
      "Talloires-Montmin",
    ],
    localSpecifics: [
      "Règlement local de publicité (RLP) d'Annecy en vigueur — cadre spécifique pour les zones patrimoniales et le pourtour du lac.",
      "Autorisation municipale requise en mairie d'Annecy pour toute enseigne lumineuse nouvelle ou modifiée.",
      "Extinction nocturne obligatoire entre 1 h et 6 h (art. R.581-59 du Code de l'environnement).",
      "Prescriptions renforcées dans les secteurs classés (Vieille Ville, Pâquier, cône de vue sur le lac).",
      "Ville engagée dans une politique de sobriété lumineuse — luminance et animations à modérer.",
    ],
    services: [
      "Étude technique gratuite sur photos de façade",
      "Croix de pharmacie LED simple face ou double face (drapeau)",
      "Croix LED programmables avec animations, heure et température",
      "Lettres boîtiers alu / inox brossé (adapté aux façades bois patrimoniales)",
      "Caducées lumineux et logos personnalisés en relief",
      "Rénovation de façades de pharmacies dans les secteurs patrimoniaux",
      "Livraison Annecy et bassin annécien",
      "Pose et raccordement (précisés dans chaque devis)",
    ],
  },

  "bourg-en-bresse": {
    slug: "bourg-en-bresse",
    city: "Bourg-en-Bresse",
    departement: "Ain",
    departementNumber: "01",
    region: "Auvergne-Rhône-Alpes",
    seoTitle: "Croix de pharmacie LED & enseignes lumineuses Bourg-en-Bresse | Signapharma France",
    metaDescription:
      "Fabricant local d'enseignes lumineuses pour pharmacies à Bourg-en-Bresse et dans l'Ain. Croix LED, lettres boîtiers, caducées — atelier basé à Saint-Jean-de-Gonville (01).",
    h1: "Croix de pharmacie et enseignes lumineuses à Bourg-en-Bresse",
    subheading:
      "Fabricant local d'enseignes lumineuses pour officines dans l'Ain et le département 01.",
    intro: [
      "Signapharma France est un fabricant local d'enseignes lumineuses pour pharmacies à Bourg-en-Bresse, préfecture de l'Ain (département 01) — département dans lequel se trouve également notre atelier de Saint-Jean-de-Gonville. Cette proximité nous permet d'offrir une réactivité forte sur les projets locaux : études sur site rapides, transports courts et SAV facilité.",
      "Nous accompagnons les pharmacies burgiennes et de tout le département de l'Ain dans leurs projets d'enseignes lumineuses : croix de pharmacie LED programmables, enseignes drapeaux double face, lettres boîtiers en aluminium ou en inox, caducées lumineux et logos rétroéclairés — pour les créations d'officines, les transferts, les rénovations ou les remplacements de croix existantes.",
    ],
    districts: [
      "Centre-ville (Champ-de-Foire, Jeanne d'Arc)",
      "Baudières",
      "Vennes",
      "Croix-Blanche",
      "Reyssouze",
      "Peloux",
      "Brou (monastère royal)",
    ],
    surroundingCities: [
      "Viriat",
      "Péronnas",
      "Saint-Denis-lès-Bourg",
      "Montagnat",
      "Ceyzériat",
      "Attignat",
      "Polliat",
      "Buellas",
      "Servas",
      "Montrevel-en-Bresse",
      "Pont-de-Veyle",
      "Villars-les-Dombes",
      "Meximieux",
      "Ambérieu-en-Bugey",
      "Oyonnax",
      "Belley",
      "Nantua",
      "Ferney-Voltaire",
      "Gex",
    ],
    localSpecifics: [
      "Règlement local de publicité de Bourg-en-Bresse en vigueur — prescriptions sur les dimensions et l'implantation des enseignes.",
      "Autorisation municipale requise pour toute enseigne lumineuse nouvelle ou modifiée.",
      "Extinction nocturne obligatoire entre 1 h et 6 h du matin (art. R.581-59 du Code de l'environnement).",
      "Prescriptions patrimoniales spécifiques autour de la Basilique de Brou (secteur protégé).",
      "Département de l'Ain : atelier Signapharma France situé dans le même département — logistique optimisée.",
    ],
    services: [
      "Étude technique gratuite sur photos de façade",
      "Croix de pharmacie LED simple face ou double face (drapeau)",
      "Croix LED programmables avec animations, heure et température",
      "Lettres boîtiers en aluminium et inox brossé",
      "Caducées lumineux et logos personnalisés en relief",
      "Rénovation et remplacement de croix existantes",
      "Livraison prioritaire dans l'Ain — délais courts (atelier départemental)",
      "Pose et raccordement électrique (précisés dans chaque devis)",
    ],
  },

  chambery: {
    slug: "chambery",
    city: "Chambéry",
    departement: "Savoie",
    departementNumber: "73",
    region: "Auvergne-Rhône-Alpes",
    seoTitle: "Croix de pharmacie LED & enseignes lumineuses Chambéry | Signapharma France",
    metaDescription:
      "Enseignes lumineuses pour pharmacies à Chambéry et en Savoie. Croix LED programmables, lettres boîtiers, caducées lumineux — étude sur mesure et pose locale.",
    h1: "Croix de pharmacie et enseignes lumineuses à Chambéry",
    subheading:
      "Fabricant et installateur d'enseignes lumineuses pour officines en Savoie et sur le bassin chambérien.",
    intro: [
      "Signapharma France réalise des enseignes lumineuses pour pharmacies à Chambéry, préfecture de la Savoie, ainsi que dans l'ensemble du bassin chambérien et de Grand Chambéry Agglomération. Notre atelier de Saint-Jean-de-Gonville (Ain) est situé à environ 1h15 de Chambéry, ce qui nous permet d'intervenir efficacement pour les études sur site, les poses et le SAV.",
      "Nos réalisations s'adressent aux pharmacies en création, en transfert, en rénovation ou souhaitant remplacer une ancienne croix. Nous fabriquons des croix de pharmacie LED programmables, des enseignes drapeaux double face, des lettres boîtiers en aluminium ou en inox brossé (adapté aux façades savoyardes patrimoniales), des caducées lumineux et des logos de pharmacie rétroéclairés.",
    ],
    districts: [
      "Chambéry-le-Vieux",
      "Centre historique (rue de Boigne, place Saint-Léger, cathédrale)",
      "Chambéry-le-Haut",
      "Faubourg Reclus",
      "Bissy",
      "Mérande",
      "Laurier",
      "Curial",
    ],
    surroundingCities: [
      "La Motte-Servolex",
      "Cognin",
      "Barberaz",
      "Bassens",
      "Sonnaz",
      "Saint-Alban-Leysse",
      "Challes-les-Eaux",
      "Aix-les-Bains",
      "Le Bourget-du-Lac",
      "Voglans",
      "Montmélian",
      "Albertville",
      "Ugine",
      "Saint-Jean-de-Maurienne",
      "Modane",
    ],
    localSpecifics: [
      "Règlement local de publicité (RLP) de Chambéry en vigueur — prescriptions patrimoniales fortes en centre historique (secteur sauvegardé).",
      "Autorisation municipale requise en mairie de Chambéry pour toute enseigne lumineuse nouvelle ou modifiée.",
      "Extinction nocturne obligatoire entre 1 h et 6 h (art. R.581-59 du Code de l'environnement).",
      "Prescriptions renforcées dans le secteur sauvegardé du centre historique (rue de Boigne, place Saint-Léger, château des Ducs de Savoie).",
      "Zone touristique et thermale : sobriété lumineuse encouragée par l'agglomération.",
    ],
    services: [
      "Étude technique gratuite sur photos de façade",
      "Croix de pharmacie LED simple face ou double face (drapeau)",
      "Croix LED programmables avec animations, heure et température",
      "Lettres boîtiers alu / inox brossé (adapté aux façades patrimoniales savoyardes)",
      "Caducées lumineux et logos personnalisés en relief",
      "Rénovation de façades de pharmacies dans les secteurs sauvegardés",
      "Livraison Chambéry, bassin chambérien et Savoie",
      "Pose et raccordement (précisés dans chaque devis)",
    ],
  },

  "aix-les-bains": {
    slug: "aix-les-bains",
    city: "Aix-les-Bains",
    departement: "Savoie",
    departementNumber: "73",
    region: "Auvergne-Rhône-Alpes",
    seoTitle: "Croix de pharmacie LED & enseignes lumineuses Aix-les-Bains | Signapharma France",
    metaDescription:
      "Enseignes lumineuses pour pharmacies à Aix-les-Bains et sur le bassin du lac du Bourget. Croix LED, lettres boîtiers, caducées — atelier Signapharma France (Ain).",
    h1: "Croix de pharmacie et enseignes lumineuses à Aix-les-Bains",
    subheading:
      "Fabricant et installateur d'enseignes lumineuses pour officines à Aix-les-Bains et sur le bassin du lac du Bourget.",
    intro: [
      "Signapharma France conçoit et installe des enseignes lumineuses pour pharmacies à Aix-les-Bains, ville thermale de Savoie située au bord du lac du Bourget. Depuis notre atelier de Saint-Jean-de-Gonville (Ain), nous rayonnons sur toute la région du Grand Lac : Aix-les-Bains, Grésy-sur-Aix, Le Bourget-du-Lac, Voglans, Bourdeau et jusqu'à Chambéry.",
      "Nous accompagnons les pharmacies aixoises dans leurs projets de création, transfert, rénovation ou remplacement d'ancienne croix : croix LED programmables, enseignes drapeaux double face, lettres boîtiers en aluminium ou en inox, caducées lumineux et logos rétroéclairés — chaque projet est étudié en tenant compte du cadre thermal et patrimonial spécifique de la commune.",
    ],
    districts: [
      "Centre-ville (esplanade du lac, place Carnot, avenue de Marlioz)",
      "Marlioz (quartier thermal et casino Grand Cercle)",
      "Franklin",
      "Choudy",
      "Boncelin",
      "Sierroz",
      "Puer",
      "Lafin",
    ],
    surroundingCities: [
      "Grésy-sur-Aix",
      "Le Bourget-du-Lac",
      "Voglans",
      "Bourdeau",
      "Trévignin",
      "Mouxy",
      "Pugny-Chatenod",
      "Drumettaz-Clarafond",
      "Méry",
      "Viviers-du-Lac",
      "Brison-Saint-Innocent",
      "La Chapelle-du-Mont-du-Chat",
      "Yenne",
      "Chambéry",
    ],
    localSpecifics: [
      "Règlement local de publicité (RLP) d'Aix-les-Bains — prescriptions renforcées en périmètre thermal, sur le front du lac et dans les secteurs Belle Époque.",
      "Autorisation municipale requise en mairie d'Aix-les-Bains pour toute enseigne lumineuse nouvelle ou modifiée.",
      "Extinction nocturne obligatoire entre 1 h et 6 h (art. R.581-59 du Code de l'environnement).",
      "Périmètre thermal Belle Époque protégé : architecture patrimoniale à respecter (thermes, casino Grand Cercle, villas).",
      "Ville engagée dans une politique de sobriété lumineuse — luminance et animations à modérer, notamment côté lac.",
    ],
    services: [
      "Étude technique gratuite sur photos de façade",
      "Croix de pharmacie LED simple face ou double face (drapeau)",
      "Croix LED programmables avec animations, heure et température",
      "Lettres boîtiers alu / inox brossé (adapté à l'architecture Belle Époque)",
      "Caducées lumineux et logos personnalisés en relief",
      "Rénovation de façades de pharmacies en périmètre thermal",
      "Livraison Aix-les-Bains, bassin du lac du Bourget et Savoie",
      "Pose et raccordement (précisés dans chaque devis)",
    ],
  },
};

export const CITIES_LIST = Object.values(LOCAL_CITIES);
